import React, { useState, useEffect } from "react";
import Header from "../common/Header";
import societies_icn from "./../../assets/images/societies-icn.svg";
import registration_icn from "../../assets/images/registrations.svg";
import search_icn from "../../assets/images/search-1.svg";
import cross_icn from "../../assets/images/cross.svg";
import {
  Select,
  Table,
  Tag,
  Button,
  DatePicker,
  Dropdown,
  Menu,
  Modal,
} from "antd";
import { EditOutlined, EllipsisOutlined } from "@ant-design/icons";
import "./societies.scss";
import { useNavigate } from "react-router-dom";
import Notify from "../common/notify/notify";

const { RangePicker } = DatePicker;

const SocietiesComponent = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  const {
    societyListData,
    callsocietyListData,
    callsocietyStatusData,
    total_society_count,
  } = props;

  const totalSocietyList = societyListData?.societyListData?.data;

  const [searchQuery, setSearchQuery] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [mark, setMark] = useState("");
  const [rangeValue, setRangeValue] = useState([null, null]);
  const [societyID, setsocietyID] = useState("");

  const [filters, setFilters] = useState({
    type: null,
    status: null,
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    callsocietyListData({
      type: null,
      startDate: null,
      endDate: null,
      status: null,
    });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1440);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    callsocietyListData(filters);
  }, [filters]);

  const handleTypeChange = (value) => {
    setFilters((prev) => ({ ...prev, type: value }));
  };
  const handleStatusChange = (value) => {
    setFilters((prev) => ({ ...prev, status: value }));
  };

  const handleDateChange = (dates, dateStrings) => {
    setFilters({
      ...filters,
      startDate: dateStrings[0],
      endDate: dateStrings[1],
    });
    setRangeValue(dates);
  };
  const handleClearFilters = () => {
    setFilters({
      type: null,
      status: null,
      startDate: null,
      endDate: null,
    });
    setSearchQuery("");
    setRangeValue([null, null]);
  };

  const isAnyFilterSelected =
    filters.type ||
    filters.status ||
    filters.startDate ||
    filters.endDate ||
    searchQuery;

  const filteredSocieties = totalSocietyList?.filter((society) => {
    const matchesSearchQuery = society?.name
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase());
    const matchesType = !filters.type || society.type === filters.type;

    const status = society.status ? society.status.toLowerCase() : "inactive";
    const matchesStatus =
      !filters.status || status === filters.status.toLowerCase();

    return matchesSearchQuery && matchesType && matchesStatus;
  });

  const societies_table_data = filteredSocieties?.map((item, index) => ({
    key: index + 1,
    societyName: item?.name,
    joinDate: new Date(item.createdAt)?.toLocaleDateString("en-GB"),
    admin: item?.president?.name || "N/a",
    contactNumber: item?.president?.phone_number || "N/a",
    emailAddress: item?.president?.email || "N/a",
    wings: item?.wingCount || "N/a",
    type: item?.type || "N/a",
    actions: item._id,
    status:
      (item.status || "Inactive").charAt(0).toUpperCase() +
      (item.status || "Inactive").slice(1),
  }));


  const ActionMenu = ({ mark, societyID }) => {
    const toggleStatus = mark.status === "Active" ? "in-active" : "active";
    setsocietyID(societyID);
    setMark(toggleStatus);

    const handleMarkStatus = async (e) => {
      setConfirmModal(true);
    };
    const handleEditPresident = () => {
      navigate(`/edit-president/${societyID}`);
    };
    const handleManageUsers = () => {
      navigate(`/manage-users/${societyID}`);
    };
    const handleToBeRegistered = () => {
      navigate(`/to-be-registered/${societyID}`);
    };

    const capitalizeFirstLetter = (text) =>
      text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    return (
      <Menu>
        <Menu.Item key="1" className="no-hover">
          <p onClick={handleMarkStatus}>
            Mark As {capitalizeFirstLetter(toggleStatus)}
          </p>
        </Menu.Item>
        <Menu.Item key="2" className="no-hover">
          <p onClick={handleEditPresident}>President Details</p>
        </Menu.Item>
        <Menu.Item key="3" className="no-hover">
          <p onClick={handleManageUsers}>Manage Users</p>
        </Menu.Item>
        <Menu.Item key="4" className="no-hover">
          <p onClick={handleToBeRegistered}>To Be Registered</p>
        </Menu.Item>
        <Menu.Item key="5" className="no-hover">
          <p onClick={() => navigate(`/society-permissions/${societyID}`)}>
            Permissions
          </p>
        </Menu.Item>
        <Menu.Item key="6" className="no-hover">
          <p onClick={() => navigate(`/society-images/${societyID}`)}>
            Images & Logo
          </p>
        </Menu.Item>
      </Menu>
    );
  };

  const handleConfirmeStatus = async () => {
    const statusDetail = await callsocietyStatusData({
      status: mark,
      societyID: societyID,
    });

    if (statusDetail.type === "societyStatus/fulfilled") {
      callsocietyListData({
        type: null,
        startDate: null,
        endDate: null,
        status: null,
      });
      setConfirmModal(false);
      Notify("success", statusDetail.payload.data.message, "");
    }
    if (statusDetail.type === "societyStatus/reject") {
      Notify("error", statusDetail.error.message, "");
    }
  };

  const societies_table_columns = [
    {
      title: "Sr. No.",
      dataIndex: "key",
      key: "key",
      render: (text) => <span>{text.toString().padStart(2, "0")}</span>,
    },
    {
      title: "Society Name",
      dataIndex: "societyName",
      key: "societyName",
      render: (name) =>
        name
          ? name
              .split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")
          : "",
    },
    {
      title: "Join Date",
      dataIndex: "joinDate",
      key: "joinDate",
    },
    {
      title: "Admin",
      dataIndex: "admin",
      key: "admin",
      render: (name) =>
        name
          ? name
              .split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")
          : "",
    },
    {
      title: "Phone Number",
      dataIndex: "contactNumber",
      key: "contactNumber",
    },
    {
      title: "Email Address",
      dataIndex: "emailAddress",
      key: "emailAddress",
    },
    {
      title: "Wings",
      dataIndex: "wings",
      key: "wings",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (priority) =>
        priority
          ? priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()
          : "",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => {
        return (
          <div className="edit-delete">
            <Button
              icon={<EditOutlined />}
              style={{ marginRight: 8 }}
              onClick={() => navigate(`/edit-details/${text.actions}`)}
            />
            <Dropdown
              overlay={<ActionMenu mark={record} societyID={text.actions} />}
              placement="bottomRight"
              trigger={["click"]}
            >
              <Button icon={<EllipsisOutlined />} />
            </Dropdown>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Header title="Societies" />
      <div className="societies-main">
        <div className="societies-first">
          <div className="left-section">
            <h1>Society List</h1>
            <p className="dec-text">
              This section provides an overview of each society's details,
              including their names, associated admin and type.
            </p>
          </div>
          <div className="right-section">
            <div className="card-1 card">
              <img src={societies_icn} alt="" />
              <div className="details">
                <h1>{total_society_count?.total_society_count || 0}</h1>
                <p>Total Societies</p>
              </div>
            </div>
            <div className="card-2 card">
              <img src={registration_icn} alt="" />
              <div className="details">
                <h1>{total_society_count?.yesterday_new_society_added || 0}</h1>
                <p>New Registrations </p>
              </div>
            </div>
          </div>
        </div>
        <div className="societies-second">
          <div className="left-section">
            <div className="search-box">
              <img src={search_icn} alt="Search" className="search-icon" />
              <input
                type="text"
                placeholder="Search by Society Name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  flex: 1,
                  border: "none",
                  outline: "none",
                  fontSize: "16px",
                  color: "#333",
                  background: "transparent",
                }}
              />
              {searchQuery && (
                <button onClick={() => setSearchQuery("")}>
                  <img src={cross_icn} alt="clear" className="clear-icon" />
                </button>
              )}
            </div>
            <Select
              className="select-type"
              placeholder="Society Type"
              onChange={handleTypeChange}
              optionFilterProp="children"
              defaultValue={"Society Type"}
              value={filters.type}
              allowClear
            >
              <Select.Option value="residential">Residential</Select.Option>
              <Select.Option value="commercial">Commercial</Select.Option>
            </Select>
            <Select
              className="select-status"
              placeholder="Society Status"
              onChange={handleStatusChange}
              value={filters.status}
              allowClear
            >
              <Select.Option value="active">Active</Select.Option>
              <Select.Option value="in-active">Inactive</Select.Option>
            </Select>
          </div>
          <div className="right-section">
            <RangePicker
              picker="date"
              onChange={handleDateChange}
              className="range-picker"
              value={rangeValue}
            />
            <button onClick={handleClearFilters} disabled={!isAnyFilterSelected}>
              Clear
            </button>
          </div>
        </div>
        <div className="societies-list">
          <Table
            dataSource={societies_table_data}
            columns={societies_table_columns}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
              defaultPageSize: 10,
            }}
            scroll={{ x: "max-content" }}
            className="society-table"
            tableLayout="fixed"
          />
        </div>
      </div>
      <Modal
        centered
        open={confirmModal}
        onCancel={() => setConfirmModal(false)}
        footer={null}
        className="approve-popup"
        style={{
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
        }}
        styles={{
          fontFamily: "Segoe UI, sans-serif",
        }}
      >
        <div
          className="user-delete-confirm-model"
          style={{
            textAlign: "center",
          }}
        >
          <div
            className="user-delete-text"
            style={{
              fontSize: "20px",
              fontWeight: "600",
              marginBottom: "24px",
              color: "#333",
            }}
          >
            Are you sure you want to change the status of this society?
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <Button
              className="user-delete-button"
              style={{
                backgroundColor: "#ff4d4f",
                border: "none",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
                transition: "all 0.3s",
              }}
              onClick={() => setConfirmModal(false)}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#ff4d4f")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#ff4d4f")}
            >
              Cancel
            </Button>
            <Button
              className="user-delete-yes-button"
              style={{
                backgroundColor: "#d6ad61",
                border: "none",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
                transition: "all 0.3s",
              }}
              onClick={handleConfirmeStatus}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#d6ad61")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#d6ad61")}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SocietiesComponent;
